export const REQUIRED_NUMBER_ERROR = 'Enter the document number';
export const NUMBER_FORMAT_ERROR = 'Enter the full document number';
